<template>
  <cms-shell :data="data" title="Textbox" @up="$emit('up', -1, data)" @down="$emit('down', 1, data)" @remove="$emit('remove', data)">
    Desktop
    <textarea type="text" class="form-control" v-model="data.value"  placeholder="Text"/>
    <br>
    Mobile
    <textarea type="text" class="form-control" v-model="data.valueMobile"  placeholder="Text"/>
  </cms-shell>
</template>

<script>
    import CmsShell from "./CmsShell";

    export default {
      components: {CmsShell},
      name: "cms-textbox",
      props:['data']
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cms/CmsTextbox.vue